<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row no-gutters>
                <v-col :cols="8">
                    <h1 class="headline font-weight-light mb-3">CLAIM</h1>
                </v-col>
            </v-row>

            <div>
                <v-tabs
                    v-model="tab"
                    background-color="blue accent-2"
                    color="lime accent-2"
                    class="elevation-2"
                    dark
                    :grow="true"
                >
                    <v-tabs-slider></v-tabs-slider>

                    <v-tab
                        v-for="i in tabs_name.length"
                        :key="i"
                        :href="`#tab-${i}`"
                        @click="change_tab(tabs_name[i - 1])"
                    >
                        <v-icon
                            class="mr-1"
                            v-if="tabs_name[i - 1] === actibe_tab"
                            >mdi-checkbox-marked-circle</v-icon
                        >
                        {{ tabs_name[i - 1] }}
                    </v-tab>

                    <v-tab-item
                        v-for="i in tabs_name.length"
                        :key="i"
                        :value="'tab-' + i"
                    >
                        <v-card flat tile>
                            <v-card-text>
                                <v-row class="mar-t-10">
                                    <v-col cols="12">
                                        <!-- table-inv -->
                                        <v-simple-table class="">
                                            <template v-slot:default>
                                                <thead>
                                                    <!-- col-tr-1 -->
                                                    <tr class="">
                                                        <th
                                                            class="text-center"
                                                            v-if="i <= 2"
                                                        >
                                                            <v-btn
                                                                small
                                                                :color="colorx"
                                                                @click="all()"
                                                                rounded
                                                                >All</v-btn
                                                            >
                                                        </th>
                                                        <th class="text-center">
                                                            #
                                                        </th>
                                                        <th class="text-center">
                                                            Case ID
                                                        </th>
                                                        <th class="text-center">
                                                            Branch
                                                        </th>
                                                        <th class="text-center">
                                                            PartNo - Singlepart
                                                        </th>

                                                        <th class="text-center">
                                                            Job Type
                                                        </th>
                                                        <th class="text-center">
                                                            Engineer
                                                        </th>

                                                        <th class="text-center">
                                                            Onsite Date
                                                        </th>
                                                        <th class="text-center">
                                                            Solution
                                                        </th>
                                                        <th class="text-center">
                                                            CSO
                                                        </th>
                                                        <th class="text-center">
                                                            Attach
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(row,
                                                        index) in data_main"
                                                        :key="index"
                                                    >
                                                        <td v-if="i <= 2">
                                                            <v-switch
                                                                v-model="
                                                                    checkbox
                                                                "
                                                                :value="
                                                                    row.subcase_id
                                                                "
                                                            ></v-switch>
                                                        </td>
                                                        <td class="text-center">
                                                            {{ index + 1 }}.
                                                        </td>
                                                        <td class="text-center">
                                                            {{ row.case_id }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                row.branch_name
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            <v-col
                                                                cols="12"
                                                                v-for="(r,
                                                                i) in row.part_srfr"
                                                                :key="i"
                                                            >
                                                                <v-btn
                                                                    :disabled="
                                                                        actibe_tab !=
                                                                            'Your Booking'
                                                                    "
                                                                    rounded
                                                                    @click="
                                                                        change_claim(
                                                                            r.part_issue_id
                                                                        )
                                                                    "
                                                                    small
                                                                    color="blue lighten-3"
                                                                    :class="
                                                                        i >= 1
                                                                            ? 'mar-t-30 cur-p'
                                                                            : ''
                                                                    "
                                                                    >{{
                                                                        r.part_name
                                                                    }}
                                                                    -
                                                                    {{
                                                                        r.singlepart
                                                                    }}</v-btn
                                                                >
                                                            </v-col>
                                                        </td>
                                                        <td class="text-center">
                                                            {{ row.case_type }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                row.enginner_name
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                row.onsite_date
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ row.solution }}
                                                        </td>
                                                        <td class="text-center">
                                                            <!-- <div
                                                                v-if="
                                                                    row.cso
                                                                        .length >
                                                                        0
                                                                "
                                                                style="display: flex justify-content: flex-end"
                                                                class="images"
                                                                v-viewer="{
                                                                    movable: false,
                                                                }"
                                                            >
                                                                <img
                                                                    width="25"
                                                                    height="25"
                                                                    v-for="(pic,
                                                                    num_pic) in row.cso"
                                                                    :key="
                                                                        num_pic
                                                                    "
                                                                    :src="
                                                                        url_pic +
                                                                            pic.file_id
                                                                    "
                                                                    class="image-cso"
                                                                />
                                                            </div> -->
                                                            <div
                                                                v-if="
                                                                    row.cso
                                                                        .length >
                                                                        0
                                                                "
                                                            >
                                                                <view-image
                                                                    :title="
                                                                        'CSO ( ' +
                                                                            row
                                                                                .cso
                                                                                .length +
                                                                            ' )'
                                                                    "
                                                                    :data="
                                                                        row.cso
                                                                    "
                                                                />
                                                            </div>
                                                        </td>
                                                        <td class="text-center">
                                                            <!-- <div
                                                                v-if="
                                                                    row.attach
                                                                        .length >
                                                                        0
                                                                "
                                                                style="display: flex justify-content: flex-end"
                                                                class="images"
                                                                v-viewer="{
                                                                    movable: false,
                                                                }"
                                                            >
                                                                <img
                                                                    width="25"
                                                                    height="25"
                                                                    v-for="(pic_a,
                                                                    num_pic_a) in row.attach"
                                                                    :key="
                                                                        num_pic_a
                                                                    "
                                                                    :src="
                                                                        url_pic +
                                                                            pic_a.file_id
                                                                    "
                                                                    class="image-cso"
                                                                />
                                                            </div> -->
                                                            <div
                                                                v-if="
                                                                    row.attach
                                                                        .length >
                                                                        0
                                                                "
                                                            >
                                                                <view-image
                                                                    :title="
                                                                        'Attach ( ' +
                                                                            row
                                                                                .attach
                                                                                .length +
                                                                            ' )'
                                                                    "
                                                                    :data="
                                                                        row.attach
                                                                    "
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <br />
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                </v-row>

                                <v-row v-if="i <= 2">
                                    <v-col cols="12" class="text-right">
                                        <v-btn
                                            color="teal lighten-2"
                                            dark
                                            small
                                            rounded
                                            @click="booking_claim()"
                                            :disabled="!checkbox.length > 0"
                                        >
                                            Book Case For Claim
                                        </v-btn>
                                        <v-btn
                                            v-if="i == 2"
                                            color="red lighten-2"
                                            dark
                                            small
                                            rounded
                                            class="ml-1"
                                            @click="reject_claim()"
                                            :disabled="!checkbox.length > 0"
                                        >
                                            Reject Waiting Claim
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
            </div>
        </v-container>

        <v-dialog v-model="dialog" max-width="500px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">CLAIM</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-dialog
                                    ref="dialog"
                                    v-model="modal"
                                    :return-value.sync="form_booking.claim_date"
                                    persistent
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="form_booking.claim_date"
                                            label="Date"
                                            prepend-icon=""
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date" scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="modal = false"
                                            >Cancel</v-btn
                                        >
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.dialog.save(date)"
                                            >OK</v-btn
                                        >
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    :items="[
                                        '5060-0024',
                                        'M0H50-30003',
                                        'M0H51-30003',
                                        'X4E75-30001',
                                        '3YP17-30001',
                                    ]"
                                    label="Code Claim"
                                    menu-props="auto"
                                    v-model="form_booking.claim_code"
                                    required
                                    hide-details
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    label="RMA"
                                    v-model="form_booking.claim_rma"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="" rounded small @click="close">Cancel</v-btn>
                    <v-btn
                        color="success darken-1"
                        rounded
                        small
                        @click="save_receive()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import Image from "../../components/ViewImage2"

const url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    components: {
        "view-image": Image,
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
    },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        async get_data() {
            console.log(this.show_type)
            this.dialog_loading = true
            await axios
                .get(url + "srfr/claim/" + this.show_type, this.tk)
                .then((response) => {
                    this.dialog_loading = false
                    this.data_main = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async booking_claim() {
            this.dialog_loading = true
            let data_send = {
                subcase_id: this.checkbox,
            }
            await axios
                .post(url + "srfr/booking-claim/", data_send, this.tk)
                .then((response) => {
                    this.colorx = ""
                    this.chk = false
                    this.dialog_loading = false
                    this.mutatesnackbar()
                    this.get_data()
                    setTimeout(() => {
                        this.mutatesnackbar()
                    }, 3000)
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        reject_claim() {
            this.$swal({
                text: "Reject Waiting Claim ?",
                showCancelButton: false,
                content: "input",
                buttons: true,
            }).then((results) => {
                if (results == null || results == undefined || results == "") {
                } else {
                    this.gotoreject_claim(this.checkbox, results)
                }
            })
        },
        async gotoreject_claim(subcase, results) {
            this.dialog_loading = true
            let data_send = {
                remark: results,
            }
            await axios
                .post(
                    url + `rejected-case-subcase/${subcase}`,
                    data_send,
                    this.tk
                )
                .then((response) => {
                    this.checkbox = ""

                    this.colorx = ""
                    this.chk = false

                    this.dialog_loading = false
                    this.mutatesnackbar()
                    this.get_data()
                    setTimeout(() => {
                        this.checkbox = []
                        this.mutatesnackbar()
                    }, 3000)
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        change_tab(change_tab) {
            this.chk = false
            this.colorx = ""
            this.checkbox = []
            this.data_main = []
            this.actibe_tab = change_tab
            if (change_tab === "Claim SVC") {
                this.show_type = "SVC"
            } else if (change_tab === "Claim WFH/Hub") {
                this.show_type = "WFH"
            } else if (change_tab === "Your Booking") {
                this.show_type = "Booking"
            } else if (change_tab === "Reject Case") {
                this.show_type = "Rejected"
            }
            this.get_data()
        },
        async change_claim(part_issue_id) {
            this.dialog = true
            this.form_booking.part_issue_id = part_issue_id
        },
        async save_receive() {
            this.dialog_loading = true
            await axios
                .post(url + "srfr/save-claim/", this.form_booking, this.tk)
                .then((response) => {
                    this.close()
                    this.dialog_loading = false
                    this.mutatesnackbar()
                    this.get_data()
                    setTimeout(() => {
                        this.mutatesnackbar()
                    }, 3000)
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        all() {
            if (this.chk === true) {
                this.chk = false
                this.colorx = ""
                this.checkbox = []
            } else {
                this.chk = true
                this.colorx = "success"
                this.data_main.map((r) => {
                    this.checkbox.push(r.subcase_id)
                })
            }
        },
        close() {
            ;(this.form_booking.claim_date = new Date()
                .toISOString()
                .substr(0, 10)),
                (this.form_booking.claim_code = "")
            this.form_booking.claim_rma = ""
            this.dialog = false
        },
    },
    data() {
        return {
            data_main: [],
            dates: [],
            dialog: false,
            modal: false,
            text: "Success, Your work has been saved",
            show_type: "SVC",
            actibe_tab: "Claim SVC",
            tabs_name: [
                "Claim SVC",
                "Claim WFH/Hub",
                "Your Booking",
                "Reject Case",
            ],
            checkbox: [],
            chk: false,
            colorx: "",
            form_booking: {
                part_issue_id: 0,
                claim_date: new Date().toISOString().substr(0, 10),
                claim_code: "",
                claim_rma: "",
            },
            url_pic: `${process.env.VUE_APP_ROOT_API}/api/case/attachments/`,
            tk: "",
            dialog_loading: false,
        }
    },
}
</script>
<style scoped>
.image-cso {
    height: 10;
    cursor: pointer;
    margin: 5px;
    display: inline-block;
}
</style>
